export default {
  methods: {
    showSnackbar(message, color, timeout) {
      this.$root.$emit('show-snackbar', message, color, timeout)
    },
  },
}
